module.exports = __webpack_public_path__ + "img/teammembers.c05af070.jpg";